import React from 'react';

import Validation from './Components/Validation'
import Position from './Components/Position'
import CancelEdit from './Components/CancelEdit';

export default function PhotoProperties({ question, position }) {
  return <>
    <p><strong>Question {question.linkId}:</strong> {question.text}</p>

    <Validation question={question} />

    <Position question={question} position={position} />

    <CancelEdit />
  </>
};